// Theme: cyber-samurai
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'cyber-samurai',
  name: 'CYBER SAMURAI',
  tagline: 'CYBER SAMURAI',
  description: 'Base preta com accent vermelho intenso e linguagem tech tatica.',
  category: 'neon-cyber',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#060608', '#0C1014', '#FF2A2A', '#F3F6FB'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '0px',
      '--shadow-card': '0 0 0 1px rgba(255, 42, 42, 0.24)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 46%, transparent)'
    },
    shellClasses: 'font-mono theme-cyber-samurai'
  },
  colorVars: {
    '--accent': '#FF2A2A',
    '--accent-foreground': '#060608',
    '--background': '#060608',
    '--border': '#2D2427',
    '--card': '#0C1014',
    '--card-border-active': 'rgba(255, 42, 42, 0.58)',
    '--card-completed': '#0A0D10',
    '--card-foreground': '#F3F6FB',
    '--card-glow': 'rgba(255, 42, 42, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#060608',
    '--foreground': '#F3F6FB',
    '--hold-fill': '#FF2A2A',
    '--input': '#2D2427',
    '--modal-bg': '#060608',
    '--modal-border': '#2D2427',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 0 0 1px rgba(255, 42, 42, 0.24)',
    '--muted': '#2D2427',
    '--muted-foreground': '#D5D9E1',
    '--nav-active': '#FF2A2A',
    '--nav-bg': '#0C1014',
    '--popover': '#0C1014',
    '--popover-foreground': '#F3F6FB',
    '--primary': '#FF2A2A',
    '--primary-foreground': '#060608',
    '--ring': '#FF2A2A',
    '--secondary': '#2D2427',
    '--secondary-foreground': '#F3F6FB',
    '--streak': '#FF2A2A',
    '--success': '#22c55e',
    '--success-foreground': '#060608',
    '--xp': '#FF2A2A',
    '--xp-bg': '#0C1014'
  },
  resolvedVars: {
    '--accent': '#FF2A2A',
    '--accent-foreground': '#060608',
    '--accent-foreground-hsl': '240 14% 3%',
    '--accent-foreground-oklch': 'from #060608 l c h',
    '--accent-hsl': '0 100% 58%',
    '--accent-oklch': 'from #FF2A2A l c h',
    '--background': '#060608',
    '--background-hsl': '240 14% 3%',
    '--background-oklch': 'from #060608 l c h',
    '--border': '#2D2427',
    '--border-hsl': '340 11% 16%',
    '--border-oklch': 'from #2D2427 l c h',
    '--border-w': '1px',
    '--card': '#0C1014',
    '--card-border-active': 'rgba(255, 42, 42, 0.58)',
    '--card-completed': '#0A0D10',
    '--card-completed-hsl': '210 23% 5%',
    '--card-completed-oklch': 'from #0A0D10 l c h',
    '--card-foreground': '#F3F6FB',
    '--card-foreground-hsl': '217 50% 97%',
    '--card-foreground-oklch': 'from #F3F6FB l c h',
    '--card-glow': 'rgba(255, 42, 42, 0.10)',
    '--card-hsl': '210 25% 6%',
    '--card-oklch': 'from #0C1014 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#060608',
    '--destructive-foreground-hsl': '240 14% 3%',
    '--destructive-foreground-oklch': 'from #060608 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F3F6FB',
    '--foreground-hsl': '217 50% 97%',
    '--foreground-oklch': 'from #F3F6FB l c h',
    '--hold-fill': '#FF2A2A',
    '--hold-fill-hsl': '0 100% 58%',
    '--hold-fill-oklch': 'from #FF2A2A l c h',
    '--input': '#2D2427',
    '--input-hsl': '340 11% 16%',
    '--input-oklch': 'from #2D2427 l c h',
    '--modal-bg': '#060608',
    '--modal-bg-hsl': '240 14% 3%',
    '--modal-bg-oklch': 'from #060608 l c h',
    '--modal-border': '#2D2427',
    '--modal-border-hsl': '340 11% 16%',
    '--modal-border-oklch': 'from #2D2427 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 0 0 1px rgba(255, 42, 42, 0.24)',
    '--muted': '#2D2427',
    '--muted-foreground': '#D5D9E1',
    '--muted-foreground-hsl': '220 17% 86%',
    '--muted-foreground-oklch': 'from #D5D9E1 l c h',
    '--muted-hsl': '340 11% 16%',
    '--muted-oklch': 'from #2D2427 l c h',
    '--nav-active': '#FF2A2A',
    '--nav-active-hsl': '0 100% 58%',
    '--nav-active-oklch': 'from #FF2A2A l c h',
    '--nav-bg': '#0C1014',
    '--nav-bg-hsl': '210 25% 6%',
    '--nav-bg-oklch': 'from #0C1014 l c h',
    '--popover': '#0C1014',
    '--popover-foreground': '#F3F6FB',
    '--popover-foreground-hsl': '217 50% 97%',
    '--popover-foreground-oklch': 'from #F3F6FB l c h',
    '--popover-hsl': '210 25% 6%',
    '--popover-oklch': 'from #0C1014 l c h',
    '--primary': '#FF2A2A',
    '--primary-foreground': '#060608',
    '--primary-foreground-hsl': '240 14% 3%',
    '--primary-foreground-oklch': 'from #060608 l c h',
    '--primary-hsl': '0 100% 58%',
    '--primary-oklch': 'from #FF2A2A l c h',
    '--radius': '0px',
    '--ring': '#FF2A2A',
    '--ring-hsl': '0 100% 58%',
    '--ring-oklch': 'from #FF2A2A l c h',
    '--secondary': '#2D2427',
    '--secondary-foreground': '#F3F6FB',
    '--secondary-foreground-hsl': '217 50% 97%',
    '--secondary-foreground-oklch': 'from #F3F6FB l c h',
    '--secondary-hsl': '340 11% 16%',
    '--secondary-oklch': 'from #2D2427 l c h',
    '--shadow-card': '0 0 0 1px rgba(255, 42, 42, 0.24)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 46%, transparent)',
    '--streak': '#FF2A2A',
    '--streak-hsl': '0 100% 58%',
    '--streak-oklch': 'from #FF2A2A l c h',
    '--success': '#22c55e',
    '--success-foreground': '#060608',
    '--success-foreground-hsl': '240 14% 3%',
    '--success-foreground-oklch': 'from #060608 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(0 100% 58% / 0.15)',
    '--xp': '#FF2A2A',
    '--xp-bg': '#0C1014',
    '--xp-bg-hsl': '210 25% 6%',
    '--xp-bg-oklch': 'from #0C1014 l c h',
    '--xp-hsl': '0 100% 58%',
    '--xp-oklch': 'from #FF2A2A l c h'
  }
}
